
export default {
  name: 'BaseProfileAuthorUserMenu',
  props: {
    username: {
      type: String,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
    isVerified: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCopyId: false,
      isShowMenu: false,
      isShowAccounters: false,
      accounters: [],
      tariffPlan: null,
    }
  },
  computed: {
    isAllow() {
      return !!this.$auth?.user?.roles?.some((role) => ['ADMIN'].includes(role))
    },
    isAccounter() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'ACCOUNTER'].includes(role)
      )
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR', 'ACCOUNTER'].includes(role)
      )
    },
    isAllowShowMenu() {
      if (!this.$auth?.loggedIn) {
        return false
      } else {
        return (
          this.$auth.user.roles.find((role) => role === 'ADMIN') ||
          this.$auth.user.roles.find((role) => role === 'MODERATOR') ||
          this.$auth.user.roles.find((role) => role === 'ACCOUNTER')
        )
      }
    },
  },
  watch: {
    accounters: {
      async handler() {
        if (this.isAllow) {
          await this.setAcconters()
          this.$emit('update')
        }
      },
      deep: true,
    },
    'tariffPlan.title'() {
      if (this.tariffPlan.title === 'USER') {
        this.tariffPlan.cost = 0
        this.tariffPlan.discount = 0
        this.tariffPlan.endDate = null
      }
    },
  },
  methods: {
    async copyId(id) {
      if (typeof navigator.clipboard === 'undefined') {
        const textArea = document.createElement('textarea')
        textArea.value = id
        textArea.style.position = 'fixed'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.isCopyId = true
        } catch (err) {
          this.isCopyId = false
        }
        document.body.removeChild(textArea)
        return
      }
      await navigator.clipboard.writeText(id).then(() => {
        this.isCopyId = true
      })
      setTimeout(() => {
        this.closeMenu()
        this.isCopyId = false
      }, 500)
    },
    userName(user) {
      if (user?.type === 'COMPANY') {
        return user?.company?.title ? user?.company?.title : user?.username
      } else {
        return user?.profile?.firstName && user?.profile?.lastName
          ? `${user?.profile.firstName} ${user?.profile.lastName}`
          : user?.username
      }
    },
    closeMenu() {
      this.isShowMenu = false
    },
    async loginAs() {
      const auth = await this.$axios.$post('/auth/loginAs', {
        username: this.username,
      })
      await this.$auth.setUserToken(auth.accessToken)
      await this.$auth.fetchUser()
      window.location.reload()
    },
    async setVerifiedAccount() {
      await this.$axios.$post('/user/setVerifiedAccount', {
        username: this.username,
      })
      window.location.reload()
    },
    async unSetVerifiedAccount() {
      await this.$axios.$post('/user/unSetVerifiedAccount', {
        username: this.username,
      })
      window.location.reload()
    },

    async createBroadcast() {
      try {
        const product = await this.$axios.$post('/advertisement/broadcast', {
          username: this.username,
        })
        this.$router.push(`/place/broadcast/content/${product._id}`)
      } catch (error) {
        this.$notify({
          type: 'error',
          text:
            error?.response?.data?.message || 'Ошибка при создании трансляции',
          position: 'bottom right',
        })
      }
    },
  },
}
